import {BaseRequest} from '@/network/requests/BaseRequest'
import {code_info} from '@/interfaces/code_info'

export const codeInfoRequest = BaseRequest.build<code_info>('code_info');
